import http from '@/services/http'

export interface UserInfo {
  /**企业名字 */
  nickname: string
  email: string
  /**是否禁用，false-不禁用，true-禁用 */
  banned: boolean
  /**仓库列表 */
  warehouseBasicInfoRespDtos: {
    /**仓库id */
    warehouseId: string
    /**string */
    warehouseName: string
    /** 仓库所在国家地区 */
    country: string
    /** 仓库详细地址 */
    address: string
    /** 当前选中的国家/地区 */
    selfArea: string
  }[]
}

export interface Premission {
  accessControl: 0 | 1
  resourceId: string
  system: string
  resourceCode: string
  resourceUrl: string
  children: Premission[]
  resourceName: string
  /** 是否禁用 */
  banned: 0 | 1
  /** 优先级（数字越大优先级越高） */
  priority: number
  /** ant插件key */
  key: string
  parentId: string
  /** 资源类型(1-菜单，2-功能) */
  resourceType: 1 | 2
}

export interface VerifyParams {
  code: string
}
/** 校验code */
export const verifyLoginCode = (data) => http.udb.get<VerifyParams>('/udb/lgn/login/verifyCode.do', { params: data })
/** 校验ticket */
export const verifyLoginTicket = (data) => http.udb.get<{ code: string }>('/udb/lgn/cas/callback.do', { params: data })

type IGetSubAccount = {
  expressTypeCode: string
  pickupType?: 1 | 2 //1:pickup；2:dropoff
}

// 子账号查询出参
export interface ISubAccountItem {
  pickupType?: 1 | 2 // 1:pickup，2:dropoff
  accountNo: string // 子账号
  remark: string // 子账号备注
  subAccountSeq?: string
}
export interface ISubAccountInfo {
  expressTypeCode: string
  subAccountDetails: ISubAccountItem[]
}

export interface UserSettingListType {
  /** 来源国家地区 */
  source_country?: string
  /** 配置编码列表 */
  setting_codes?: string[]
}

export interface UserSettingListResType {
  extMap?: Record<string, any>
  settings: {
    settingCode: string
    dataType: any
    dataValue: string
  }[]
}
export interface IInfoProps {
  oneshipName: string
  notificationEmail?: string
}

/**
 * 获取子账号
 * @param params
 * @returns
 */
export const getSubAccount = (params: IGetSubAccount) => http.admin.post<ISubAccountInfo>('/api/user/sub_account/get', params)

/**
 * 获取用户设置
 * @param params
 * @returns
 */
export const getUserSettingList = (params: UserSettingListType = {}) => {
  return http.admin.post<UserSettingListResType>('/api/user/setting/list', {
    ...params,
    source_system: 'ONE01',
  })
}

export interface checkEmailTypeRes {
  sellerName: string
  /**
   * 1个人用户
   */
  userType: string
  token: string
}

export interface CountryCheckRes {
  countryCode: string
}

/**
 * 更新用户信息
 * @returns
 */
export const updateUserInfo = (data: IInfoProps) => http.admin.post('/api/user/info/update', data)

/* 配置的settingCode */
export type SettingKeyType =
  | 'WAYBILL_PRINT'
  | 'CURRENCY_RATE'
  | 'GOODS_TRANSLATE'
  | 'ORDER_TAB_FEATURE'
  | 'SALES_TAB_FEATURE'
  | 'ON_DEMAND_ORDER_TAB_FEATURE'
  | 'ON_DEMAND_SALES_TAB_FEATURE'
  | 'ORDER_SORT_FEATURE'
  | 'SALES_SORT_FEATURE'
  | 'ON_DEMAND_ORDER_SORT_FEATURE'
  | 'ON_DEMAND_SALES_SORT_FEATURE'
  | 'SALES_COLUMN_FEATURE'
  | 'ORDER_COLUMN_FEATURE'
  | 'MERGE_DELIVERY_SWITCH'
  | 'HIDE_COMMODITY' // 面单展示商品信息
  | 'WAYBILL_PRINT_EXT_FEATURE' // 加打拣货单
  | 'TICKET_PRINT_EXT_FEATURE' // 捡货单设置
  | 'TICKET_PRINT_FEATURE' // 捡货单纸张设置
  | 'WAYBILL_PRINT_ORIGIN_ORDER' // 是否显示原订单号
  | 'ADDRESS_MATCH_FEATURE'
  | 'EMAIL_PICKED'
  | 'USER_DEFAULT_CURRENCY_CODE' // 钱包默认币种
  | 'DEFAULT_PACKAGE_SIZE' // 默认包裹尺寸
  | 'WAYBILL_DESENSITIZATION_FEATURE' // 面单打印脱敏设置
  | 'SELLER_FEE_SETTING_SWITCH' // 运费自定义设置
  | 'WAYBILL_DESENSITIZATION_FEATURE' // 面单打印脱敏设置
  | 'SELLER_TERMS_ACCEPTED' // 是否已阅读渠道的发货条款
  | 'SHOP_CAPABILITY_REMIND_SETTING' // 首页渠道串接卡片是否关闭

export interface SettingUpdateParams {
  settingCode: SettingKeyType
  dataValue: string | number
}

/* 保存用户配置 */
export const postUpdateSetting = (settings: SettingUpdateParams[]) => http.admin.post('/api/user/setting/update', { settings })

/** 获取用户配置 */
export const getFeatureKeys = () => http.admin.post('/api/crm/admin/subscription/rights/feature-keys')

export interface ServiceKeys {
  /**业务编码 */
  serviceKeys?: string[]
  /**是否无限期的 */
  indefinite?: boolean
}

/** 商家有效service key查询 */
export const getServiceKeys = (params?: ServiceKeys) =>
  http.admin.post('/api/crm/admin/subscription/rights/service-keys', {
    params: {
      ...params,
    },
  })

/**
 * 获取权限树
 * @returns
 */
export const getUserPermissionTree = () => http.admin.post<{ extMap: any; resourceTree: Premission[] }>('/api/auth/resource/list')

/**
 * 商家是否至少有一个商家授权的服务产品
 * @returns
 */
export const hasSellerAuthExpressType = () => {
  return http.admin.post<{ hasSellerAuthExpressType: boolean; hasAppApply: boolean }>('/api/seller/express/type/auth/valid')
}

export enum OsContractStatusEnum {
  /** 未签约 */
  UNSIGNED = 'unsigned',
  /** 已完成 */
  SIGNED = 'signed',
}
export interface ContractDetailRes {
  /**是否成功 */
  isSuccess?: boolean
  /**扩展属性 */
  extMap?: any
  /**商家结算方式（结算方式：monthly_statement月结,prepaid预付） */
  settlementMethod?: string
  /**
   * 商家的os签约状态,预付商家才需要判断签约状态, 签约状态如果是已完成，可以允许准入,签约状态如果是签署中，直接使用oaUrl跳转
   * APPROVE_TERMINATE( "APPROVE_TERMINATE","审批终止" ),DELETED( "DELETED","发起人拒签" ),
   * DECLINED( "DECLINED","已拒签" ),VOIDED( "VOIDED","签署终止" ),
   * COMPLETED( "COMPLETED","已完成" ),TIMEOUT( "TIMEOUT","已过期" ),SENT( "SENT","签署中" )
   * */
  osContractStatus?: string
  /**oa签约url（预付）如果此url为空，需要先跳转到填空写合同,如果此url非空，则直接跳转到此url继续签约 */
  oaContractUrls?: { oaContractUrl: string; phone: number; thirdSignStates: string[] }[]
}
/**
 * **接口** [获取商家签约状态（用于判断准入）↗](https://api-doc-sl.inshopline.com/#/project/Java/74/feature%2F20230626_1510_contract/interface/0207602c7e82b7a6c91785da204453a9)
 * @请求头 `POST /api/seller/contract/detail`
 * @更新时间 `2023-06-05 10:37:11`
 */
export function postContractDetail() {
  return http.admin.post<ContractDetailRes>(`/api/seller/contract/detail`, { urlType: 'CONTRACT_H5_LIST' })
}
